"use strict";

export const calculateFoldDistance = (event) => {
    const estimator = event.target.form;
    const { footingWidth, footingHeight, wallThickness, epsThickness, battenWidth, battenThickness, fastfootSize, foldDistanceResult } = estimator.elements;

    const foldDistanceExact =
      8.71 +
      (+footingWidth.value / 2 - +wallThickness.value / 2 - +epsThickness.value - 2) *
        0.8 +
      (+footingHeight.value - 6) * 1.1 +
      +footingWidth.value / 2 +
      +battenWidth.value +
      +battenThickness.value / 2;

    switch (true) {
        case 2 * foldDistanceExact + 3 <= 50:
            fastfootSize.value = "FF50";
        break;
        case 50 < 2 * foldDistanceExact + 3 <= 62:
            fastfootSize.value = "FF62";
        break;
        case 62 < 2 * foldDistanceExact + 3 <= 74:
            fastfootSize.value = "FF74";
        break;
        case 2 * foldDistanceExact + 3 > 74:
        alert(
            "Footing too large to monopour. Contact Fab-Form to discuss (888)303-3278"
        );
        break;
    }

    foldDistanceResult.value = Math.floor(foldDistanceExact * 10) / 10;
};